export const safeLocalStorageGet = (
  key: string,
  logger: (...args: any[]) => void
): string | null => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    logger('Error getting local storage key:', key, error);
    return null;
  }
};

export const safeLocalStorageSet = (
  key: string,
  value: string,
  logger: (...args: any[]) => void
): void => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    logger('Error setting local storage key:', key, 'value:', value, error);
  }
};
